import * as React from 'react'
import { TextField, List, ListItemText, ListItemButton} from '@mui/material'
import { getPlaces } from '../utility/loaders'

export const AddressForm =({formik}) => {
    const [suggestions, setSuggestions] = React.useState([])
    const [selectedIndex, setSelectedIndex] = React.useState(0)
    
    const firstName = formik.values.first_name
    const lastName = formik.values.last_name
    const email = formik.values.email
    const secondAddress = formik.values.street_address_2 || ''

    
    
    
    const handleInputChange = async(query) =>{
        const pulledSuggestions = await getPlaces(query)
        setSuggestions(pulledSuggestions)   

    }

    const handleChange = (event) =>{
        
        formik.values.street_address_1 = event.target.value
        handleInputChange(event.target.value)
    }
    
    const handleSuggestionClick = (event, index, firstName, lastName, email ) =>{
        
        setSelectedIndex(index)
        
       const addressSelected = suggestions[selectedIndex].place_name
       
       const street_address_1 = addressSelected.split(',')[0]
       
       const addressObject = {
        street_address_1: street_address_1,
        place: "",
        region: "",
        postcode: "",
       }

       suggestions[selectedIndex].context.forEach((element)=>{
        const identifier = element.id.split(".")[0]
        
        if(identifier==='region'){
            addressObject[identifier] = element.short_code.slice(3); 
        } else{
            addressObject[identifier] = element.text;
        }

       })

       
       
       formik.setValues({
       street_address_1: addressObject.street_address_1,
       street_address_2: secondAddress,
       city: addressObject.place,
       state: addressObject.region,
       zip: addressObject.postcode,
       zip4: "",
       first_name: firstName,
       last_name: lastName,
       email: email
       })
       
       

       setSuggestions([])

        
        

    }
    


return(
    <React.Fragment>
    <TextField fullWidth
     type='text' 
     id='address'
     name='address'
     label='Address Search'
     value={formik.values.street_address_1}
     onChange={handleChange} />
     <List>
        {suggestions?.map((suggestions,index)=>(
            <ListItemButton
              key={index}
              selected={selectedIndex === index}
              onClick={(event)=> handleSuggestionClick(event, index, firstName, lastName, email)}
              >  
            <ListItemText primary={suggestions.place_name}/>
            </ListItemButton>
            
        ))}

     </List>
     </React.Fragment>
   
)

}